import { NavigationSubItem } from "../navigation-item"

export class DiagnosticsMoreSubItem extends NavigationSubItem {
  readonly id = "diagnostics"
  readonly label = "Diagnostics"
  readonly href = "/diagnostics"
  readonly iconName = "diagnostics-icon"
  readonly isExternal = false
  readonly tabs = []
}
